'use strict';

module.exports = image;

function image(h, node) {
  var props = {
    url: node.properties.src || '',
    title: node.properties.title || null,
    alt: node.properties.alt || null
  };

  return h(node, 'image', props);
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/hast-util-to-mdast/handlers/image.js
// module id = 1027
// module chunks = 0